import { render, staticRenderFns } from "./products-filter.vue?vue&type=template&id=7cdedf4c&"
import script from "./products-filter.vue?vue&type=script&lang=js&"
export * from "./products-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports